import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { getAppDotOrigin } from '../util'

const RegisterLink = (
  { children, ...props },
  { useRelativeRegistrationLink }
) =>
  useRelativeRegistrationLink ? (
    <Link to="/register/submit/li" {...props}>
      {children}
    </Link>
  ) : (
    <a href={`${getAppDotOrigin()}/register/submit/li`} {...props}>
      {children}
    </a>
  )

RegisterLink.propTypes = {
  children: PropTypes.node.isRequired,
}

RegisterLink.contextTypes = {
  appId: PropTypes.string.isRequired,
  useRelativeRegistrationLink: PropTypes.bool.isRequired,
}

export default RegisterLink



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/RegisterLink.js